import { useEffect, useState } from 'react';
import axios from 'axios';
import { X, Sparkles } from 'lucide-react';
import { API } from '../constants';

const PromoBanner = () => {
  const [promo, setPromo] = useState(null);
  const [dismissed, setDismissed] = useState(() => {
    if (typeof window === 'undefined') return false;
    return sessionStorage.getItem('promo-banner-dismissed') === '1';
  });

  useEffect(() => {
    let ignore = false;
    axios.get(`${API}/promo`).then((res) => {
      if (!ignore) setPromo(res.data);
    }).catch(() => {});
    return () => { ignore = true; };
  }, []);

  const handleDismiss = () => {
    sessionStorage.setItem('promo-banner-dismissed', '1');
    setDismissed(true);
  };

  if (!promo || !promo.active || dismissed) return null;

  return (
    <div
      className="relative bg-gradient-to-r from-[#D62828] via-[#b91c1c] to-[#D62828] text-white text-center py-2 px-10 text-xs sm:text-sm font-semibold tracking-wide uppercase shadow-md border-b border-white/10"
      data-testid="promo-banner"
    >
      <div className="flex items-center justify-center gap-2 flex-wrap">
        <Sparkles className="w-4 h-4 text-yellow-300 animate-pulse" />
        <span data-testid="promo-banner-text">{promo.banner_text}</span>
        <Sparkles className="w-4 h-4 text-yellow-300 animate-pulse" />
      </div>
      <button
        onClick={handleDismiss}
        className="absolute right-2 top-1/2 -translate-y-1/2 p-1 rounded hover:bg-white/10 transition-colors"
        aria-label="Dismiss promo banner"
        data-testid="promo-banner-dismiss"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};

export default PromoBanner;
